import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Box, Text, Anchor, Stack } from 'grommet';
import { Close } from 'grommet-icons';
import { startCase } from '../../lib/nodash';

import SmartLink from '../SmartLink';
import useMobile from '../useMobile';

const getFilterHref = (baseUrl, item) => {
  return `${baseUrl || ''}${
    item.slug.includes('colorIndex')
      ? '?sort=colorIndex'
      : `${item.slug.replace('color:', '')}-paint`
  }`;
};

const ColorFilterPanelItem = ({
  item,
  isActive,
  onTagFilter,
  onSort,
  labelKey,
  labelPrepend,
  size = 'large',
  layout = 'vertical',
  baseUrl,
  canonicalLinks,
}) => {
  const isMobile = useMobile();
  const isSort = item.sort || item.component === 'Sort';
  const isHorizontal = layout === 'horizontal';
  const targetSize = isHorizontal ? '24px' : isMobile ? '44px' : '30px';
  const iconSize = isHorizontal ? '14px' : isMobile ? 'medium' : '18px';

  return (
    <SmartLink
      onClick={(e) => {
        e.preventDefault();
        isSort ? onSort(item) : onTagFilter(item);
      }}
      as={Box}
      compAs={Anchor}
      plain
      to={
        canonicalLinks ? getFilterHref(baseUrl, item) : window.location.pathname
      }
      direction="row"
      wrap={false}
      gap="xsmall"
      justify="between"
      align="center"
      flex="grow"
      focusIndicator={false}
      pad={isMobile ? { vertical: 'small', horizontal: '12px' } : 'xsmall'}
      className="list-paint-filter-item"
      style={{
        textDecoration: 'none',
        outline: 'none',
        breakInside: 'avoid',
      }}
    >
      <Box
        className="type"
        wrap={false}
        align="center"
        flex={false}
        width="3em"
        gap={'small'}
        direction={isHorizontal ? 'row' : 'row-responsive'}
      >
        <Stack fill justify="center" align="center">
          <Box align="center" flex={false}>
            <Box
              round={'100%'}
              background={item.hexValue || 'light-2'}
              height={targetSize}
              width={targetSize}
              border={{ side: 'all', size: 'xsmall' }}
              flex={false}
            />
          </Box>
          {isActive && (
            <Box fill background="rgba(255, 255, 255, 0.75)" align="center">
              <Close
                color="black"
                size={iconSize}
                style={{ marginTop: isMobile ? '10px' : '6px' }}
              />
            </Box>
          )}
        </Stack>
        <Text size="small" textAlign="center" weight={isActive ? 500 : 400}>
          {labelPrepend && labelPrepend}
          {labelKey ? item[labelKey] : startCase(item)}
        </Text>
      </Box>
    </SmartLink>
  );
};

ColorFilterPanelItem.propTypes = {
  item: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  isActive: PropTypes.bool,
  onTagFilter: PropTypes.func,
  onSort: PropTypes.func,
  labelKey: PropTypes.string,
  valueKey: PropTypes.string,
  labelPrepend: PropTypes.string,
  size: PropTypes.string,
  activeFilters: PropTypes.array,
  baseUrl: PropTypes.string,
  canonicalLinks: PropTypes.bool,
  layout: PropTypes.string,
};

export default memo(ColorFilterPanelItem);
